import React, { useEffect, useRef, useState } from 'react'
import { Card, Col, Row, Button, ProgressBar } from 'react-bootstrap'
import CommonCard from '../../../Components/common/CommonCard'
import ApexCharts from 'react-apexcharts';
import Select from "react-select"
import { Skeleton } from '@mui/material';
import { CallApi } from "../../../Components/common/CommonFunctions"
import { GETDESTINATION } from '../../../Utils/conts.js';

import tripstoday from '../../../assets/images/slotplanning/tripstoday.svg';
import inprogress from '../../../assets/images/icon_svg/bord_icon.svg';
import { ReactComponent as Time } from "../../../assets/images/recovery_dahboard/time.svg";
import { ReactComponent as Trucks } from "../../../assets/images/icon_svg/truck_icon.svg";
import { ReactComponent as Chart } from "../../../assets/images/icon_svg/chart_icon.svg"; 
import { ReactComponent as Dis } from "../../../assets/images/icon_svg/dis_icon.svg"; 
import { ReactComponent as Filter } from "../../../assets/images/icon_svg/filter.svg";  
import { ReactComponent as Flag } from "../../../assets/images/icon_svg/flag.svg";
import { ReactComponent as Warning } from "../../../assets/images/icon_svg/warning.svg";
import { ReactComponent as Arrow } from "../../../assets/images/icon_svg/arww_wth_crcl.svg"; 
import { ReactComponent as Close } from "../../../assets/images/icon_svg/reset_icon.svg";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; 
import { faAngleRight } from '@fortawesome/free-solid-svg-icons'; 
import { toast } from 'react-toastify'; 
import DiscrepancyModal from './Components/DiscrepancyModal.js';

const Dashboard = ({ onDetails }) => {
  const [boardpoint, setGetBoardPoint] = useState([]);
  const [offPoint, setOffPoint] = useState([]);
  const [selectedBoardPoint, setSelectedBoardPoint] = useState(null);
  const [selectedOffPoint, setSelectedOffPoint] = useState(null);
  const [dashboardData, setDashboardData] = useState(null);
  const [dashboardLoading, setDashboardLoading] = useState(true);
  const [destinationLoading, setDestinationLoading] = useState(true);
  const isMounted = useRef(null)
  const tableRef = useRef(null);
  const PAGE_SIZE = 50;
  const [discrepancies, setDiscrepancies] = useState([]);
  const [discrepancySummary, setDiscrepancySummary] = useState({
    TotalRows: 0,
    planningCount: 0,
    operationalCount: 0,
  });
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true); 
  
  const iconMap = { tripstoday, inprogress };

  const cards = [
    { icon: 'inprogress', title: 'Open Truck Orders', value: dashboardData?.open_truck_orders ?? 0 },
    { icon: 'tripstoday', title: 'In Transit',         value: dashboardData?.in_transit         ?? 0 },
  ];

  const defaultChartOptions = (categories, horizontal = false) => ({
    chart: {
      type: 'bar',
      height: 350,
      toolbar: { show: false },
      zoom: { enabled: false },
    },
    plotOptions: {
      bar: {
        horizontal,
        columnWidth: '55%',
        endingShape: 'rounded',
        // borderRadius: 4,
        borderRadiusApplication: 'end',
        borderRadiusWhenStacked: 'last',
        dataLabels: { position: 'top' },
      },
    },
    markers: { size: 4, strokeWidth: 2, strokeColors: "#1D4ED8" },
    dataLabels: {
      enabled: true,
      offsetY: horizontal ? 0 : -20,
      offsetX: horizontal ? 20 : 0,
      formatter: (val) => val,
      style: { fontSize: '12px', colors: ["#000"], fontWeight: 'bold' },
      background: { enabled: false },
    },
    // stroke: { show: true, curve: 'smooth', width: 2, colors: ['#1D4ED8'] },
    xaxis: {
      categories,
      labels: { style: { fontSize: '12', colors: ["#000"], fontWeight: 600 } },
    },
    yaxis: {
      title: { text: '' },
      min: 0,
        // max: 500,
        // tickAmount: 5,
      labels: { formatter: (val) => (typeof val === 'number' ? Math.round(val) : val),
        style: {
        fontSize: '14px',
          }
       },
    },
    fill: {
      opacity: 1,
      type: 'gradient',
      colors: horizontal? ['#90a8eb']  : ['#3460dc'], 
      gradient: {
        shade: 'light',
        type: horizontal ? 'horizontal' : 'vertical',
        shadeIntensity: 0.5,
        gradientToColors: horizontal ? ['#3460dc']  : ['#90a8eb'],
        inverseColors: false,
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 100],
      },
    },
    tooltip: { y: { formatter: (val) => val + " units" } },
  });

  const toStatusCategories = Object.keys(dashboardData?.truck_orders_status_breakdown ?? {});
  const toStatusValues     = Object.values(dashboardData?.truck_orders_status_breakdown ?? {});
  const tdCategories       = Object.keys(dashboardData?.upcoming_truck_departures ?? {});
  const tdValues           = Object.values(dashboardData?.upcoming_truck_departures ?? {});

  const fetchDestination = () => {
    setDestinationLoading(true);
    CallApi({
      endPoint: GETDESTINATION,
      onSuccess: (res) => {
        const innerData = res?.data;
        if (innerData?.response_code == 200) {
          const destOptions = (innerData.response_data || []).map((item) => ({
            label: item.port_code,
            value: item.port_code,
            ...item,
          }));
          const regionOpt = [{ label: "All Stations", value: "all" }, ...destOptions];
          setGetBoardPoint(regionOpt);
          setOffPoint(regionOpt);
        } else {
          toast.error(innerData?.response_msg);
        }
        setDestinationLoading(false);
      },
      onError: (msg) => {
        toast.error(msg);
        setDestinationLoading(false);
      },
    });
  };
  const handleScroll = () => {
    const el = tableRef.current;
    if (!el || discrepancyLoading || !hasMore) return;
    const reachedBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 20;
    if (reachedBottom) {
      setPage((prev) => prev + 1);
    }
  };

  const fetchDashboard = (bp = null, op = null) => {
    const boardpointParam = bp && bp !== "all" ? JSON.stringify([bp]) : JSON.stringify([]);
    const offpointParam   = op && op !== "all" ? JSON.stringify([op]) : JSON.stringify([]);

    setDashboardLoading(true);
    CallApi({
      endPoint: `/rfs/dashboard?boardpoint=${boardpointParam}&offpoint=${offpointParam}`,
      method: "GET",
      onSuccess: (res) => {
        const data = res?.data ?? res;
        if (data?.response_code == 200) {
          setDashboardData(data.response_data);
        } else {
          toast.error(data?.response_msg);
        }
        setDashboardLoading(false);
      },
      onError: (msg) => {
        toast.error(msg);
        setDashboardLoading(false);
      },
    });
  };

  const handlePointChange = (type, selected) => {
    if (type === "clear") {
      setSelectedBoardPoint(null);
      setSelectedOffPoint(null);
      fetchDashboard(null, null);
      // fetchDiscrepancies(null, null);
      return;                          
    }

    const newBoardPoint = type === "bp" ? selected : selectedBoardPoint;
    const newOffPoint   = type === "op" ? selected : selectedOffPoint;

    if (type === "bp") setSelectedBoardPoint(selected);
    else if (type === "op") setSelectedOffPoint(selected);
    else {setSelectedBoardPoint(null); setSelectedOffPoint(null)}

    fetchDashboard(newBoardPoint?.value ?? null, newOffPoint?.value ?? null);
};

  useEffect(() => {
    if (isMounted.current) return;
    fetchDashboard();
    fetchDestination();
    // fetchDiscrepancies();
    isMounted.current = true;
  }, []);

  useEffect(() => {
    setPage(1);
    setHasMore(true);
    fetchDiscrepancies(1, selectedBoardPoint?.value, selectedOffPoint?.value, true);
  }, [selectedBoardPoint, selectedOffPoint]);

  useEffect(() => {
    if (page === 1) return;
    fetchDiscrepancies(page, selectedBoardPoint?.value, selectedOffPoint?.value, false);
  }, [page]);

  const [discrepancyLoading, setDiscrepancyLoading] = useState(false);
  const [showDiscrepancyModal, setShowDiscrepancyModal] = useState(false);
  const [selectedDiscrepancy, setSelectedDiscrepancy] = useState(null);
  const fetchDiscrepancies = ( pageNo = 1, bp = null, op = null, reset = false) => {
  if (discrepancyLoading) return;
  const boardpointParam =
    bp && bp !== "all" ? JSON.stringify([bp]) : JSON.stringify([]);
  const offpointParam =
    op && op !== "all" ? JSON.stringify([op]) : JSON.stringify([]);

  setDiscrepancyLoading(true);

  CallApi({
    endPoint: `/discrepancy/get-all-discrepancy?boardpoint=${boardpointParam}&offpoint=${offpointParam}&status=O&pagesize=${PAGE_SIZE}&page=${pageNo}`,
    method: "GET",
    onSuccess: (res) => {
      const data = res?.data ?? res;
      if (data?.responseCode === 1) {
        const rows = data.Rows || [];
        if (reset) {
          setDiscrepancies(rows);
        } else {
          setDiscrepancies((prev) => [...prev, ...rows]);
        }
        setDiscrepancySummary({
          TotalRows: data.TotalRows ?? 0,
          planningCount: data.planningCount ?? 0,
          operationalCount: data.operationalCount ?? 0,
        });
        setHasMore(rows.length === PAGE_SIZE);
      } else {
        toast.error(data?.response_msg);
      }

      setDiscrepancyLoading(false);
    },
    onError: (msg) => {
      toast.error(msg);
      setDiscrepancyLoading(false);
    },
  });
};
const handleTruckOrderNavigate = (data) => {
    localStorage.setItem('TODetails', data.truck_plan_monitor_mapping_id);
    const ed = `${data.truck_number || ''}/${data.truck_date ? data.truck_date.split(' ')[0] : ''}`;
    onDetails?.('', 'TOD', ed);
};

 const isInitialLoading = discrepancyLoading && page === 1 && discrepancies?.length === 0;
  return (
    <div className="main-content">
      <Row>
        <Col sm="4">
          <div>
            {cards?.length ?
              <div className="card-bx">
                {cards?.map((item, index) => (
                  <CommonCard
                    key={index}
                    icon={iconMap[item.icon]}
                    title={item.title}
                    value={dashboardLoading ? <Skeleton variant="text" width={40} /> : item.value}
                  />
                ))}
              </div>
              : <></>
            }
          </div>

          <div className='global_roundbg'>
            <div className='box_icon_text'>
              <span className='border_icon'><Chart width={16} height={16} /></span>
              <h3>Truck Order Status Breakdown</h3>
            </div>
            {dashboardLoading ? (
              <Skeleton variant="rectangular" width="100%" height={318} style={{ borderRadius: 6 }} />
            ) : (
              <ApexCharts
                options={defaultChartOptions(toStatusCategories, true)}
                series={[{ name: 'Orders', data: toStatusValues }]}
                type="bar"
                height={318}
                ref={isMounted}
              />
            )}
          </div>

          <div className='global_roundbg mt-4'>
            <div className='box_icon_text'>
              <span className='border_icon'><Trucks width={16} height={16} /></span>
              <h3>Upcoming Truck Departures</h3>
            </div>
            {dashboardLoading ? (
              <Skeleton variant="rectangular" width="100%" height={318} style={{ borderRadius: 6 }} />
            ) : (
              <ApexCharts
                options={defaultChartOptions(tdCategories, false)}
                series={[{ name: 'Orders', data: tdValues }]}
                type="bar"
                height={318}
                ref={isMounted}
              />
            )}
          </div>
        </Col>
       <Col sm="5">
          <div className='global_roundbg h-100'>
            <div className='d-flex justify-content-between align-items-center mb-2'>
              <div className='box_icon_text mb-0'>
                <span className='border_icon'><Dis width={16} height={16} /></span>
                <h3>Discrepancy Overview</h3>
              </div>
              <div>
                <button className="viewall_btn">
                  View All<span><FontAwesomeIcon icon={faAngleRight} /></span>
                </button>
              </div>
            </div>

            {isInitialLoading ? (
              <>
                <div className='mb-2 p-2 dis_overview text-center'>
                  <Skeleton variant="text" width="80%" style={{ margin: '0 auto' }} />
                </div>
                <div className='table-wrapper table-responsive max-hgt-88'>
                  <table className='global_table table'>
                    <thead>
                      <tr><th>Mismatch</th><th>Truck No.</th><th>Station</th><th></th></tr>
                    </thead>
                    <tbody>
                      {Array.from({ length: 6 }).map((_, i) => (
                        <tr key={`dis_skel_${i}`}>
                          <td><Skeleton variant="text" width="90%" /></td>
                          <td><Skeleton variant="text" width="70%" /></td>
                          <td><Skeleton variant="text" width="50%" /></td>
                          <td><Skeleton variant="circular" width={20} height={20} /></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            ) : discrepancies.Rows?.length === 0 ? (
              <div className='px-2 pt-4 text-center no_item_text'>No discrepancies detected</div>
            ) : (
              <>
                <div className='mb-2 p-2 dis_overview text-center'>
                  <Warning width={16} height={16} />
                  <span><b> {discrepancySummary.TotalRows} </b>Total Discrepancies</span>
                  <span><b> {discrepancySummary.planningCount} </b>Planning</span>
                  <span><b> {discrepancySummary.operationalCount} </b>Operational</span>
                </div>

                <div ref={tableRef} onScroll={handleScroll} className='table-wrapper table-responsive max-hgt-88'>
                  <table className='global_table table'>
                    <thead>
                      <tr><th>Mismatch</th><th>Truck No.</th><th>Station</th><th></th></tr>
                    </thead>
                    <tbody>
                      {discrepancies?.map((item, index) => (
                        <tr key={item.id ?? index}>
                          <td>{item.list?.title ?? item.mismatch ?? '—'}</td>
                          <td>{item.truck_number ?? '—'}</td>
                          <td>{item.station ?? '—'}</td>
                          <td>
                            <span
                              style={{ cursor: 'pointer' }}
                              onClick={() => {
                                setSelectedDiscrepancy(item);
                                setShowDiscrepancyModal(true);
                              }}
                            >
                              <Arrow />
                            </span>
                          </td>
                        </tr>
                      ))}
                      {discrepancyLoading && page > 1 &&  (
                        <tr>
                          <td colSpan={4} className="text-center p-2">Loading more...</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </>
            )}
          </div>
        </Col>
        <Col sm="3">
          <div>
            <div className="global_roundbg h-100">
              <div className='d-flex justify-content-between align-items-center mb-2'>
                <div className='box_icon_text'>
                <span className='border_icon'><Filter width={16} height={16} /></span>
                <h3>Filters</h3>
              </div>
              <div>
                {(selectedBoardPoint || selectedOffPoint) && (
                <Button variant='contained' className="danger_btn" onClick={() => handlePointChange("clear")} > <Close width={16} height={16} /> Clear Filters </Button>
                )}
              </div>

              </div>
              

              <div className="gl_title">Boardpoint</div>
              {destinationLoading ? (
                <Skeleton variant="rectangular" height={38} style={{ borderRadius: 6 }} />
              ) : (
                <Select
                  options={boardpoint}
                  value={selectedBoardPoint}
                  onChange={(selected)=>handlePointChange("bp",selected)}
                  placeholder="Select Boardpoint"
                  className="region_selct"
                  name="region_id"
                />
              )}

              <div className="gl_title mt-3">Offpoint</div>
              {destinationLoading ? (
                <Skeleton variant="rectangular" height={38} style={{ borderRadius: 6 }} />
              ) : (
                <Select
                  options={offPoint}
                  value={selectedOffPoint}
                  onChange={(selected)=>handlePointChange("op",selected)}
                  placeholder="Select Offpoint"
                  className="region_selct"
                  name="region_id"
                />
              )}
            </div>

            <div className='mt-3'>
              <div className='global_roundbg mb-3 min-hgt-10'>
                <div className='box_icon_text'>
                  <span className='border_icon'><Flag width={18} height={18} /></span>
                  <h3>Open Trucks (Boardpoint)</h3>
                </div>
                {dashboardLoading ? (
                  Array.from({ length: 4 }).map((_, i) => (
                    <div className='bar_list' key={`trucks_skel_${i}`}>
                      <div className='d-flex justify-content-between align-items-center mb-1 bar_box'>
                        <Skeleton variant="text" width="40%" />
                        <Skeleton variant="text" width="30%" />
                      </div>
                      <Skeleton variant="rectangular" height={8} style={{ borderRadius: 4 }} />
                    </div>
                  ))
                ) : dashboardData?.open_trucks_boardpoint?.length ? (
                  dashboardData.open_trucks_boardpoint.map((item, index) => {
                    return (
                      <div key={index} className='bar_list'>
                        <div className='d-flex justify-content-between align-items-center mb-1 bar_box'>
                          <h3>{item.boardpoint}</h3>
                          <div className='ship_text'>
                            <span className='count_ship'>{item.count} Trucks</span>
                            <span className='percetage'>{item.percentage || 0}%</span>
                          </div>
                        </div>
                        <ProgressBar now={item.percentage || 0} />
                      </div>
                    );
                  })
                ) : <></>}
              </div>

              <div className='global_roundbg min-hgt-10'>
                <div className='box_icon_text'>
                  <span className='border_icon'><Flag width={18} height={18} /></span>
                  <h3>Open Shipment (Boardpoint)</h3>
                </div>
                {dashboardLoading ? (
                  Array.from({ length: 4 }).map((_, i) => (
                    <div className='bar_list' key={`shipments_skel_${i}`}>
                      <div className='d-flex justify-content-between align-items-center mb-1 bar_box'>
                        <Skeleton variant="text" width="40%" />
                        <Skeleton variant="text" width="30%" />
                      </div>
                      <Skeleton variant="rectangular" height={8} style={{ borderRadius: 4 }} />
                    </div>
                  ))
                ) : dashboardData?.open_shipments_boardpoint?.length ? (
                  dashboardData.open_shipments_boardpoint.map((item, index) => {
                    return (
                      <div key={index} className='bar_list'>
                        <div className='d-flex justify-content-between align-items-center mb-1 bar_box'>
                          <h3>{item.boardpoint}</h3>
                          <div className='ship_text'>
                            <span className='count_ship'>{item.count || 0} Shipments</span>
                            <span className='percetage'>{item.percentage || 0}%</span>
                          </div>
                        </div>
                        <ProgressBar now={item.percentage || 0} />
                      </div>
                    );
                  })
                ) : <></>}
              </div>
            </div>
          </div>
        </Col>

      </Row>
      <DiscrepancyModal
        key={selectedDiscrepancy?.id}
        show={showDiscrepancyModal}
        onHide={() => {
          setShowDiscrepancyModal(false);
          setSelectedDiscrepancy(null);
        }}
        truckData={selectedDiscrepancy}
        timeComp={[]}
        onDetails={handleTruckOrderNavigate}
      />
    </div>
  );
};

export default Dashboard;